export enum APPROVAL {
    PENDING = 1,
    // REVISI = 2,
    REJECT = 3,
    APPROVE = 4
}